<template>
  <div class="user-list">

    <el-table @sort-change="editSort" @row-click="openUser" :data="visits" class="zebra-table">
      <el-table-column width="70" prop="" label="">
        <template slot-scope="scope">
          <letters-avatar v-if="scope.row" :name="scope.row.user.name" size="32" type="mini"/>
        </template>
      </el-table-column>

      <el-table-column sortable="custom" prop="user.name" label="Клиент">
        <template slot-scope="scope">
          <div class="user-data">
            <div class="user-data__name">{{ scope.row.user.name }}</div>
            <div class="user-data__phone"> {{ scope.row.user.phone }}</div>
          </div>
          <div class="user-id">ID:{{ scope.row.user.id }}</div>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="date_start" label="Время визита" :formatter="formatter">
        <template slot-scope="scope">

          <div class="time-point" v-if="scope.row.date_end">
            <div class="time-point__date">{{ $root.dateDefault(scope.row.date_end) }}</div>
            <div class="time-point__time"><i class="el-icon-time"></i> {{ $root.timeIso(scope.row.date_start) }} -
              {{ $root.timeIso(scope.row.date_end) }}
            </div>
          </div>

        </template>
      </el-table-column>
      <el-table-column prop="id" label="Сеанс"></el-table-column>
      <el-table-column prop="inspection_status_text" label="Статус"></el-table-column>

      <el-table-column sortable="custom" prop="worker" label="Специалист" align="right">
        <template slot-scope="scope">
          <div class="worker">
            <div v-if="scope.row.worker">{{ scope.row.worker.name }}</div>
            <i class="el-icon-back"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
import LettersAvatar from "@/components/elements/LettersAvatar"

export default {
  name: "UserList",
  props: {
    visits: {},
    history: {
      type: Boolean
    },
    noClick: {
      type: Boolean
    }
  },
  data: () => {
    return {}
  },
  components: {LettersAvatar},
  computed: {},
  methods: {
    zebra(item) {
      return (this.noClick && (item % 2 == 0)) ? true : false
    },
    openUser(user) {
      this.$emit('openUser', user)
    },
    formatter(row) {
      return row.address;
    },
    editSort(data) {
      this.$emit('sort-change', data)
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.zebra-table /deep/ .el-table__row .cell {
  color: #676767 !important;
  cursor: pointer;
}

.user-data {
  display: flex;
  justify-content: flex-start;
  align-content: center;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;


  &__name {
    font-weight: 600;
    font-size: 15px;
    line-height: 16px;

    color: #111111;
  }

  &__phone {
    font-size: 15px;
    line-height: 16px;

    color: #111;
    margin-left: 10px;

  }

}

.user-id {
  margin-top: 4px;
}

.time-point {


  &__date {
    font-size: 15px;
    line-height: 16px;
    color: #111111;

  }

  &__time {
    margin-top: 4px;

    font-size: 15px;
    line-height: 16px;
    color: #8E8E93;
  }
}

.worker {
  display: flex;
  justify-content: flex-end;
  align-items: center;


  i {
    color: #43D3B3;
    margin-left: 28px;
  }
}

.zebra-table {
  margin-top: 32px;

  font-size: 15px;
  line-height: 16px;
  color: #676767;

  /deep/ .el-table__row {
    height: 60px;
  }
}

</style>
